import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "react-bootstrap";

// Recursive function to render a single dropdown item with indentation for sub-accounts
const renderDropdownItem = (account, level = 0, onClickFunction) => {
  const colors = ["#f5f5f5", "#e0e0e0", "#cccccc", "#b3b3b3", "#999999"];
  const backgroundColor = colors[level % colors.length];
  const indentation = {
    paddingLeft: `${level * 20 + 20}px`,
    backgroundColor: backgroundColor,
  };

  return (
    <div key={account.Id}>
      <DropdownItem
        style={indentation}
        onClick={() => {
          onClickFunction(account);
        }}
      >
        {account.Name}
      </DropdownItem>
      {account.SubAccounts &&
        Object.values(account.SubAccounts).map((subAccount) =>
          renderDropdownItem(subAccount, level + 1, onClickFunction)
        )}
    </div>
  );
};

// Recursive function to filter accounts and their sub-accounts based on search text
const filterAccounts = (accounts, searchText) => {
  const filtered = [];

  for (let account of accounts) {
    const subAccounts = account.SubAccounts
      ? Object.values(account.SubAccounts)
      : [];

    const filteredSubAccounts = filterAccounts(subAccounts, searchText);

    const accountNameMatches = account.Name.toLowerCase().includes(
      searchText.toLowerCase()
    );

    if (accountNameMatches || filteredSubAccounts.length > 0) {
      filtered.push({
        ...account,
        SubAccounts:
          filteredSubAccounts.length > 0
            ? Object.fromEntries(filteredSubAccounts.map((sa) => [sa.Id, sa]))
            : undefined,
      });
    }
  }

  return filtered;
};

const HierarchicalDropdown = ({
  data,
  togglerText,
  children,
  onClickFunction,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  const toggle = (nextShow) => {
    setIsOpen(nextShow);
  };

  useEffect(() => {
    if (searchText.trim() === "") {
      setFilteredData(data);
    } else {
      const filtered = filterAccounts(data, searchText);
      setFilteredData(filtered.length > 0 ? filtered : []);
    }
  }, [searchText, data]);

  return (
    <Dropdown
      show={isOpen}
      onToggle={toggle}
      style={{ width: "100%", textTransform: "capitalize" }}
    >
      <DropdownToggle
        variant="light"
        style={{
          width: "100%",
          textTransform: "capitalize",
          textAlign: "left",
        }}
      >
        {togglerText}
      </DropdownToggle>
      <DropdownMenu
        style={{
          maxHeight: "200px",
          overflowY: "scroll",
          width: "100%",
        }}
      >
        <input
          type="text"
          className="form-control mx-2"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: "90%", marginBottom: "10px" }}
        />
        {children}
        {filteredData.length > 0 ? (
          filteredData.map((account) =>
            renderDropdownItem(account, 0, onClickFunction)
          )
        ) : (
          <div className="text-center text-muted">No results found.</div>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default HierarchicalDropdown;
